export default __webpack_public_path__ + "static/media/icon1.64fc8a92.svg";